import axios from 'axios'
import store from '../store'

axios.interceptors.response.use(
  res => {
    return res
  },
  async err => {
    const originalConfig = err.config

    if (err.response && err.response.data.status_code) console.log(err.response.data.message)
    else console.log('Terjadi kesalahan system')

    if (originalConfig.url !== '/auth/signin' && err.response.data.status_code == 401) {
      store.commit('auth/SIGNOUT')
      localStorage.removeItem('token')
      localStorage.removeItem('cms')
    }

    return Promise.reject(err)
  }
)

export const setHeader = () => {
  let token = localStorage.getItem('token')
  axios.defaults.baseURL = process.env.MIX_URL
  axios.defaults.headers.get['Content-Type'] = 'application/json'

  if (token) {
    axios.defaults.headers.authorization = 'Bearer ' + token
  }
}
